export default __webpack_public_path__ + "static/media/CC_SubmarkLogo_Colour.a2792845.svg";